import { useState, useEffect } from 'react';
import useAPIData from './useAPIData';

export default function useSelectedData(requestURL, holdRequest) {
  const [selectedData, setSelectedData] = useState();
  const [dataChange, setDataChange] = useState(false);
  const apiData = useAPIData(requestURL, holdRequest, dataChange);

  useEffect(() => {
    if (apiData) {
      setSelectedData(apiData);
    }
  }, [apiData]);

  const handleDataChange = (rowName, value) => {
    if (rowName) {
      setSelectedData({ ...selectedData, [rowName]: value });
    }
    setDataChange(true);
  };

  const restDataChange = () => {
    setDataChange(false);
  };

  return [selectedData, dataChange, restDataChange, handleDataChange];
}
